import { FC } from "react"
import BaseIconButton, { IIconButtonProps } from "../BaseIconButton"
import * as ChatIcons from "../../../../libs/corporate/icons/outlined/other/ChatCollection"

export const NewsChatButton:FC<IIconButtonProps> = ({count, ...props})=>{
    return (
        <BaseIconButton {...props}>
            <ChatIcons.NewsChatIcon count={count} />
        </BaseIconButton>
    )
}